import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { Injectable } from '@angular/core';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { KYMW4500Model } from '../kymw4500.model';

// レスポンス構造
export type GetApprovalFlowListResponse = {
  ApprovalFlowType: string;
  ApprovalFlowTypeName: string;
};

/**
 * 承認フロー区分一覧取得
 *
 * @export GetApprovalFlowListService
 * @class GetApprovalFlowListService
 * @extends {PlessResponderSub}
 */
@Injectable()
export class GetApprovalFlowListService extends PlessJsonResponderSub<GetApprovalFlowListResponse[]> {
  private successFunc: Function;
  private model: KYMW4500Model;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetApprovalFlowListService
   */
  private getBody(): PlessRequest {
    return new PlessRequest();
  }

  /**
   * API呼び出し
   * @param vo 
   * @param successFunc
   * @memberof GetApprovalFlowListService
   */
  execute(model: KYMW4500Model, successFunc: Function = null): void {
    this.model = model;
    this.successFunc = successFunc;
    this.send('getApprovalFlowList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetApprovalFlowListService
   */
  success(data: GetApprovalFlowListResponse[]) {
    this.model.setApprovalFlowList(data);
    if (this.successFunc) this.successFunc();
  }
}
